import axios from 'axios';
import Forms from '../components/forms';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
import { loadRecaptcha } from '../app';

export default class ComponentFormularioSejaNossoParceiro {
	constructor() {
		this.form = document.querySelector('#formPartner');
		this.successMessage = document.querySelector('.component-seja_nosso_parceiro .success-form')
		this.errorMessage = document.querySelector('.component-seja_nosso_parceiro .error-form')
		this.btnSubmit = this.form.querySelector('button');

		this.ready();
		this.startreCaptcha();
	}

	startreCaptcha() {
		const allInputs = this.form.querySelectorAll('input, select, textarea');
		allInputs.forEach(field => {
			field.addEventListener('focus', loadRecaptcha);
		});
	}

	ready() {
		new Bouncer(`#formPartner`, {
			fieldClass: 'error-field',
			disableSubmit: true,
			...Forms.wrongMessages(),
		});

		this.form.addEventListener(
			'bouncerFormValid',
			(event) => {
				event.preventDefault();
				if (event.target.id === this.form.id) {
					// Verificar se o reCAPTCHA Enterprise foi respondido
					if (typeof grecaptcha.enterprise !== 'undefined' && grecaptcha.enterprise.getResponse() !== '') {
						this.sendFormContactAjax(event.target);
					} else {
						console.log('Por favor, complete o reCAPTCHA antes de enviar o formulário.');
						// Aqui você pode exibir uma mensagem para o usuário informando que o reCAPTCHA precisa ser respondido
					}
				}
			},
			false
		);
	}

	sendFormContactAjax(form) {
		this.btnSubmit.disabled = true;

		const response = grecaptcha.enterprise.getResponse();
		if (response.length == 0) {
			console.log('reCaptcha not verified')
			document.querySelector('.greCaptchaError').classList.remove('noShow')
			this.btnSubmit.disabled = false;
			return
		} else {
			document.querySelector('.greCaptchaError').classList.add('noShow')

			const dataForm = new FormData(form);

			if (this.form.querySelector('#privacy').checked) {
				dataForm.set('privacy', 1);
			} else {
				dataForm.set('privacy', 0);
			}

			axios({
				method: 'POST',
				url: urlSite + '/ajax/send_partner.php',
				data: dataForm,
				headers: { 'Content-Type': 'multipart/form-data' },
			})
				.then(() => {
					form.reset();
					this.btnSubmit.disabled = false;
					this.successMessage.classList.remove('noShow');
					this.errorMessage.classList.add('noShow');

					setTimeout(() => {
						this.successMessage.classList.add('noShow');
					}, 5000);

				})
				.catch(() => {
					console.log('Erro');
					this.successMessage.classList.add('noShow');
					this.errorMessage.classList.remove('noShow');
					this.btnSubmit.disabled = false;
				});
		}
	}
}
